import {
  GETBUSINESSNATUREMAPPINGLIST_SUCCESS,
  GETBUSINESSNATUREMAPPINGLIST_FAILED,
  RESET_GETBUSINESSNATUREMAPPINGLIST,
  LOADING_GETBUSINESSNATUREMAPPINGLIST,
  NETWORK_ERROR_GETBUSINESSNATUREMAPPINGLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetBusinessNatureMappingList = () => {
  return { type: RESET_GETBUSINESSNATUREMAPPINGLIST };
};

const getBusinessNatureMappingList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETBUSINESSNATUREMAPPINGLIST });
    await adminServices
      .post("getBusinessNatureMappingList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(getBusinessNatureMappingListsuccess(res.data));
            break;
          default:
            dispatch(getBusinessNatureMappingListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETBUSINESSNATUREMAPPINGLIST,
          payload: err,
        });
      });
  };
function getBusinessNatureMappingListsuccess(data) {
  return {
    type: GETBUSINESSNATUREMAPPINGLIST_SUCCESS,
    payload: data,
  };
}
function getBusinessNatureMappingListFailed(data) {
  return {
    type: GETBUSINESSNATUREMAPPINGLIST_FAILED,
    payload: data,
  };
}

export { resetGetBusinessNatureMappingList, getBusinessNatureMappingList };
